export default function (field, options) {
    if (field !== null && field !== "" && field !== undefined) {
        return options.fn(this);
    } else {
        return options.inverse(this);
    }
}